var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9fOc2U0RveQk2aFRPnPPO"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["admin-panel@flicket-ltd"]={id:"9fOc2U0RveQk2aFRPnPPO"};
      